// extracted by mini-css-extract-plugin
export default {"dashboard1":"Dashboard_dashboard1__WavZ+","dashboard2":"Dashboard_dashboard2__oxDKA","dashboard3":"Dashboard_dashboard3__-23ox"};